// Green Monday 2025 Countdown Timer
(() => {
  const banner = document.getElementById('green-monday-banner');
  if (!banner) return;

  const countdownElement = banner.querySelector('.green-monday-banner__countdown');
  if (!countdownElement) return;

  // Thursday January 30, 2026 at 11:59 PM EST
  const targetDate = new Date('2026-01-30T23:59:00-05:00');

  function updateCountdown() {
    const now = new Date();
    const diff = targetDate - now;

    // If the date has passed, hide the banner
    if (diff <= 0) {
      banner.style.display = 'none';
      return;
    }

    // Calculate time units
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // Update the countdown display
    countdownElement.innerHTML = `
      <span class="countdown-item">
        <strong>${days}</strong>
        <span class="countdown-label">Days</span>
      </span>
      <span class="countdown-separator">:</span>
      <span class="countdown-item">
        <strong>${hours}</strong>
        <span class="countdown-label">Hours</span>
      </span>
      <span class="countdown-separator">:</span>
      <span class="countdown-item">
        <strong>${minutes}</strong>
        <span class="countdown-label">Min</span>
      </span>
      <span class="countdown-separator">:</span>
      <span class="countdown-item">
        <strong>${seconds}</strong>
        <span class="countdown-label">Sec</span>
      </span>
    `;
  }

  // Update immediately and then every second
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();
